import { prop } from 'ramda';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSocketSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';

import { toggleReconnectVisible } from '../store/actions';

export const useAppNotifier = () => {
    const dispatch = useDispatch();
    const connected = useSocketSelector(prop('connected'));
    const [online, setOnline] = useState(true);
    const prevConnected = usePrevious(connected);

    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        dispatch(toggleReconnectVisible(!connected && prevConnected || !online));
    }, [
        dispatch,
        online,
        connected,
        prevConnected
    ]);
};
